import type { FC } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';


import {
  EmptyListMessageTitle,
  EmptyListMessage,
  EmptyListContainer,
} from './EmptyListView.style';
import { withBamLayoutSelector } from '@redux/user/selectors';

const EmptyListView: FC = () => {
  const colors = useSelector(colorsSelector);
  const withBamLayout = useSelector(withBamLayoutSelector);

  return (
    <EmptyListContainer>
      <EmptyListMessageTitle>
        <FormattedMessage id={withBamLayout ? 'waiting-list.empty-list-message-title-bam' : 'waiting-list.empty-list-message-title'} />
      </EmptyListMessageTitle>
      <EmptyListMessage {...{ colors }}>
        <FormattedMessage id='waiting-list.empty-list-message-bam' />
      </EmptyListMessage>
    </EmptyListContainer>
  );
};

export default EmptyListView;
